import { useEffect, useState } from 'react'

import ReactDOM from 'react-dom'

import { AttachmentBox } from '../AttachmentBox'

import { FileUploadResult } from '@/hooks/useAttachmentUpload'

type Props = {
  fileList: FileUploadResult[]
  renderAttachmentsElementId?: string
  removeFile?: (uid: string) => void
  renderingInPdf?: boolean
  size?: number
  onEdit?: (file: FileUploadResult) => void
}

export const UploaderAttachments: React.FC<Props> = ({
  fileList,
  renderAttachmentsElementId,
  removeFile,
  renderingInPdf,
  size = 72,
  onEdit,
}) => {
  const [domIsReady, setDomIsReady] = useState(false)

  useEffect(() => {
    setDomIsReady(true) // wait for DOM to load before looking for the portal
  }, [])

  const attachments = fileList.map((file) => (
    <AttachmentBox
      key={file.uid ?? file.url ?? file.name}
      width={size}
      height={size}
      attachment={{
        uid: file.uid,
        url: file.url,
        alt: file.name,
        percent: file.percent,
        previewUrl: file.url,
        onRemove: removeFile ? () => removeFile(file.uid) : undefined,
        onEdit: onEdit ? () => onEdit(file) : undefined,
      }}
      renderingInPdf={renderingInPdf}
    />
  ))

  if (renderAttachmentsElementId) {
    if (!domIsReady) return null

    const portal = document.getElementById(renderAttachmentsElementId)

    if (!portal) return null

    return ReactDOM.createPortal(attachments, portal)
  }

  return attachments
}
